import React from 'react';
import './PromoCodesList.pcss';
import PromotionModel from '@mm/state/model/PromotionModel';

type Props = {
  promotions: PromotionModel[];
};

const PromoCodesList = ({ promotions }: Props) => {
  if (promotions && promotions.length) {
    return (
      <div className="promo-codes-list">
        <div className="promo-codes-list__header">
          Available promotional codes
        </div>

        <div className="promo-codes-list__list-wrapper">
          {promotions.map(promotion => (
            <div key={promotion.id} className="promo-codes-list__item">
              {promotion.code}
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default PromoCodesList;
